import React, { useState } from "react";
import { Form, Row, Col, Offcanvas } from "react-bootstrap";
import RespIm from "./RespIm";
import "../css/botones.css";
import "bootstrap/dist/css/bootstrap.min.css";
function LogIn(props) {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState({ show: false, message: "" });
  const handleClose = () => setShow({ show: false, message: "" });
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    }
  };
  return (
    <div
      style={{
        alignContent: "center",
        paddingLeft: "1%",
        paddingRight: "1%",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <a href="https://www.entrenamientopostural.com/">
          <RespIm
            x0={1003}
            y0={700}
            x={300}
            src={require("../images/Logo.png").default}
          />
        </a>
      </div>
      <div>
        <Offcanvas show={show.show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <RespIm
                x0={1003}
                y0={700}
                x={200}
                src={require("../images/Logo.png").default}
              />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>{show.message}</Offcanvas.Body>
        </Offcanvas>
      </div>

      <Row
        fluid
        noGutters={true}
        className="justify-content-center"
        style={{ margin: "auto" }}
      >
        <Col Col xs={12} xl={10}>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
            id="Forma"
          >
            <Form.Group className="mb-3" controlId="userName">
              <Form.Label> Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Ingrese su email"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su email
              </Form.Control.Feedback>
              <Form.Text className="text-muted"></Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="userPassWord">
              <Form.Label> Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Ingrese su contraseña"
                required
              />
              <Form.Control.Feedback type="invalid">
                Por favor ingrese su clave
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Col>
      </Row>

      <Row
        fluid
        noGutters={true}
        className="justify-content-center"
        style={{ paddingTop: "4px", margin: "auto" }}
      >
        <Col
          xs={6}
          xl={3}
          className="text-center"
          style={{ paddingTop: "15px", margin: "auto" }}
        >
          <button class="botones2" onClick={() => ingresar(props)}>
            Ingresar
          </button>
        </Col>
        <Col
          Col
          xs={6}
          xl={3}
          className="text-center"
          style={{ paddingTop: "15px", margin: "auto" }}
        >
          {"   "}
          <button class="botones2" onClick={() => props.setEstado({ n: 4 })}>
            Olvide mi clave
          </button>
        </Col>
        <Col
          xs={12}
          xl={3}
          className="text-center"
          style={{ paddingTop: "15px", margin: "auto" }}
        >
          <button class="botones2" onClick={() => props.setEstado({ n: 0 })}>
            Volver
          </button>
        </Col>
      </Row>
      <Row
        fluid
        className="justify-content-center"
        style={{ paddingTop: "40px", margin: "auto" }}
      ></Row>
    </div>
  );
  async function ingresar(props) {
    localStorage.removeItem("Jwt");
    const form = document.getElementById("Forma");
    if (form.checkValidity() === true) {
      let userName = document.getElementById("userName").value;
      let userPassWord = document.getElementById("userPassWord").value;
      loggeame(userName, userPassWord)
        .then((json) => {
          if (json) {
            if (json.status === 200) {
              props.setEstado({
                n: 10,
                data: { nombre: json.data.nombre, url: "" },
              });
            }
            if (json.status === 201) {
              props.setEstado({ n: 5, data: json.data });
            }
            if (json.status === 401) {
              setShow({
                show: true,
                message: json.message,
              });
            }
            if (json.status === -401) {
              setShow({
                show: true,
                message: json.message,
              });
            }
          } else {
            alert("Error");
          }
        })
        .catch((error) => alert(error));
    } else {
      setValidated(true);
    }
  }
  async function loggeame(userName, userPassWord) {
    const res = await fetch(
      "https://entrenamientopostural.com/services/PHP/logIn.php",
      {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },

        body: JSON.stringify({
          email: userName,
          clave: userPassWord,
        }),
      }
    );

    if (res.status === 200) {
      const json = await res.json();
      localStorage.setItem("Jwt", json.data.jwt);
      return json;
    }
    if (res.status === 401) {
      const json = await res.json();
      return json;
    } else {
      return false;
    }
  }
}
export default LogIn;
